import { useWindowSize } from 'react-use';

export default function useIsMobile() {
  const { width } = useWindowSize();
  return width <= 480;
}
